'use client'

import useNextRouter from '@/hooks/useNextRouter';
import { ButtonHTMLAttributes, useEffect } from 'react';

interface BackProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    customUrl: string;
    forceUrl?: boolean;
}

const SmartBackButton = ({ customUrl, children, forceUrl = false, ...props }: BackProps) => {
    const router = useNextRouter();
    const handleBackNavigation = () => {
        const isExternalReferrer = !!document.referrer && (new URL(document.referrer).origin !== window.location.origin);

        if (isExternalReferrer || forceUrl) {
            // Redirect to the custom page passed as a prop
            router.push(customUrl);
        } else {
            // Navigate to the previous page within the app
            router.back();
        }
    };


    return (
        <button {...props} onClick={handleBackNavigation}>
            {children}
        </button>
    );
};

export default SmartBackButton;
